import styled from "styled-components";
import { Colors } from "../../config";
import ConfirmRequestTravellerDetailsContainer from "./ConfirmRequestTravellerDetailsContainer";

const ConfirmRequestTravellerDetails = ({
  passengers,
  guests,
  formData,
  extraFields,
}) => {
  return (
    <>
      <StyledBox>
        <HeadingWrapper>Traveller Details</HeadingWrapper>
        <ConfirmRequestTravellerDetailsContainer
          passengers={passengers}
          guests={guests}
          formData={formData}
          extraFields={extraFields}
        />
      </StyledBox>
    </>
  );
};

const StyledBox = styled.div`
  background: ${Colors.white};
  padding: 2.438rem 2.25rem;
  border-radius: 0.75rem;
  min-height: calc(100vh - 22rem);
  // height: calc(100vh - 22rem);
  // overflow-y: scroll;
  // &::-webkit-scrollbar {
  //   width: 0.875rem;
  //   -webkit-appearance: none;
  // }

  // &::-webkit-scrollbar-thumb {
  //   height: 3.625rem;
  //   border: 4px solid rgba(0, 0, 0, 0);
  //   background-clip: padding-box;
  //   border-radius: 0.625rem;
  //   background-color: ${Colors.brandOne};
  // }

  @media only screen and (min-width: 481px) and (max-width: 768px) {
    // height: calc(100vh - 39rem);
    min-height: auto;
    padding: 1.625rem 1.5rem;
  }

  @media only screen and (max-width: 480px) {
    // height: 100vh;
    min-height: auto;
    padding: 1.625rem 1.5rem;
  }
`;

const HeadingWrapper = styled.div`
  color: ${Colors.brandTwo};
  font-weight: 700;
  font-size: 1.625rem;

  @media only screen and (max-width: 480px) {
    font-size: 1.125rem;
  }
`;

export default ConfirmRequestTravellerDetails;
